export default defineNuxtPlugin(() => {
  const route = useRoute();
  watch(
    () => route.path,
    (newPath) => {
      useSwajarKurikulumStore().$patch({
        materiType: /agenda-2/.test(newPath) ? "k2" : "k1",
      });
    },
    { immediate: true },
  );
});
